import { Injectable, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../services/auth.service';
import { TermsService } from '../services/terms.service';

@Injectable({
  providedIn: 'root',
})
export class TermsGuard implements CanActivate {

  public jwtHelperService = new JwtHelperService();
  private isInitialized = false;

  constructor(
    readonly router: Router,
    readonly auth$: AuthService,
    readonly termsService: TermsService
  ) { }

  public canActivate() {
    const channel: { channelCode: any } = JSON.parse(
      localStorage.getItem('userChannelInfo')
    );

    const accessToken = localStorage.getItem('accessToken');
    const isTokenExpired = this.jwtHelperService.isTokenExpired(accessToken);

    if (!isTokenExpired && !this.isInitialized) {
      this.termsService
        .findMyTerms(channel?.channelCode || '0', accessToken)
        .subscribe(
          (response) => {
            this.isInitialized = true;
            
            setTimeout(() => {
              this.isInitialized = false;
            }, 5000);

            this.termsService.termsDataError$.next(false);
            let rememberLater = localStorage.getItem('isRememberLater')
              ? localStorage.getItem('isRememberLater')
              : false;
            const myTerms = response.terms;
            const termsNotAccepted = myTerms?.filter(
              (term) => term.termVersion.status !== 'ACCEPTED'
            );
            const requiredTerms = termsNotAccepted?.filter(
              (term) => term.termVersion.acceptanceRequired
            );

            if (
              termsNotAccepted?.length &&
              requiredTerms.length &&
              !rememberLater
            ) {
              this.router.navigate(['/terms']).then(() => {
                setTimeout(() => {
                  this.termsService.termsData$.next(termsNotAccepted);
                  this.termsService.termIsMandatoryAcceptance$.next(
                    response.isMandatoryAcceptance
                  );
                }, 1);
              });
              return false;
            } else {
              this.router.navigate(['/']);
              return true;
            }
          },
          (error: HttpErrorResponse) => {
            this.termsService.termsData$.next([]);
            this.termsService.termsDataError$.next(true);
            this.router.navigate(['/terms']);
            return false;
          }
        );
    }

    return true;
  }
}
